import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import { connect } from 'react-redux'

import Error from '../../pages/errors/Error'
import Loading from '../../pages/Loading'
import { fetchMaintenancePeriods } from '../../../actions/maintenancePeriods'

const mapStateToProps = ({ maintenancePeriods : { isFetching, data: { isClosedForMaintenance, maintenancePeriod}} }) => {
  return {
    maintenancePeriod: maintenancePeriod,
    isClosedForMaintenance: isClosedForMaintenance,
    isFetchingMaintenancePeriods : isFetching
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMaintenancePeriods: () => {
      dispatch(fetchMaintenancePeriods())
    },
  }
}

class CheckForMaintenance extends Component {
  constructor (props) {
    super(props)
  }

  componentDidMount() {
    this.props.fetchMaintenancePeriods();
  }

  render() {
    if (this.props.isFetchingMaintenancePeriods) {
      return <Loading/>
    }

    if (this.props.isClosedForMaintenance) {
      return <Error
        className="page__error--maintenance"
        title={this.props.maintenancePeriod.title}
        longDescription={this.props.maintenancePeriod.outageMessage}
        hideContactInfo={true}
      />
    }

    return this.props.children
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckForMaintenance))